"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NestableWidget = void 0;
const tslib_1 = require("tslib");
const t = (0, tslib_1.__importStar)(require("io-ts"));
const BooleanField_1 = require("./BooleanField");
const Color_1 = require("./Color");
const Date_1 = require("./Date");
const Embed_1 = require("./Embed");
const GeoPoint_1 = require("./GeoPoint");
const Image_1 = require("./Image");
const IntegrationField_1 = require("./IntegrationField");
const Link_1 = require("./Link");
const Number_1 = require("./Number");
const Range_1 = require("./Range");
const RichText_1 = require("./RichText");
const Select_1 = require("./Select");
const Separator_1 = require("./Separator");
const Text_1 = require("./Text");
const Timestamp_1 = require("./Timestamp");
exports.NestableWidget = t.union([
    Color_1.Color,
    BooleanField_1.BooleanField,
    Embed_1.Embed,
    GeoPoint_1.GeoPoint,
    Date_1.Date,
    Number_1.Number,
    Range_1.Range,
    RichText_1.RichText,
    Select_1.Select,
    Separator_1.Separator,
    Text_1.Text,
    Timestamp_1.Timestamp,
    Link_1.Link,
    Image_1.Image,
    IntegrationField_1.IntegrationField,
]);
